import * as React from 'react'
import { Button, CircularProgress } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

type Props = {
  loading?: boolean
} & React.ComponentProps<typeof Button>

/**
 * default button
 */
export const Component: React.SFC<Props> = function ({
  children,
  loading,
  disabled = false,
  ...props
}) {
  const s = useStyles({})

  return (
    <Button
      variant="contained"
      disabled={loading || disabled}
      {...props}
      classes={{ root: s.button }}
    >
      {children}
      {loading && <CircularProgress size={24} className={s.progress} />}
    </Button>
  )
}

export default Component

const useStyles = makeStyles({
  progress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  button: {
    borderRadius: 25,
    fontSize: 15,
    paddingTop: 5,
    paddingBottom: 5,
    lineHeight: '25px',
    textTransform: 'none',
  },
})
